module.exports = ".kan-remove-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/dialogs/remove-dialog/component.scss
// module id = ./src/modules/common/dialogs/remove-dialog/component.scss
// module chunks = main